// router/RouterProvider.jsx
import useReferralCode from "@hooks/useReferralCode";
import SocialAuthRedirect from "./wrapper.socialRedirector";

export default function RouterProvider({ children }) {
  useReferralCode();
  return (
      <SocialAuthRedirect>
        {children}
      </SocialAuthRedirect>
  );
}
